import { render, staticRenderFns } from "./Talhao.vue?vue&type=template&id=0237cf78&scoped=true"
import script from "./Talhao.vue?vue&type=script&lang=js"
export * from "./Talhao.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=0237cf78&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237cf78",
  null
  
)

export default component.exports